/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_My_Integrations_TitleInputs */



/**
* | output |
* | --- |
* | "Your integrations" |
*
* @param {Connections_My_Integrations_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_my_integrations_title = /** @type {((inputs?: Connections_My_Integrations_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_My_Integrations_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Integrationen")
	return /** @type {LocalizedString} */ ("Your integrations")
});